import { jsx as _jsx } from "react/jsx-runtime";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeProductImageUrl } from "@faire/web--source/common/transform-images";
import React from "react";
import styled from "styled-components";
export var InsightCardProductImage = function(param) {
    var image = param.image, asCarouselTile = param.asCarouselTile, shouldShowVerticalImagery = param.shouldShowVerticalImagery, isCompact = param.isCompact;
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(Image, {
        src: image ? getImageUrl(image, isSSR, !!shouldShowVerticalImagery, isCompact) : EAEAEA_PIXEL,
        alt: image === null || image === void 0 ? void 0 : image.alt_text,
        $squared: asCarouselTile && !shouldShowVerticalImagery,
        loading: undefined,
        style: {
            width: "100%",
            height: "100%"
        },
        width: "100%",
        height: "100%"
    });
};
var Image = styled.img.withConfig({
    componentId: "sc-17d427e5-0"
})([
    "display:block;width:100%;height:100%;object-fit:contain;",
    ""
], function(props) {
    return props.$squared ? "aspect-ratio: 1;" : "";
});
var getImageUrl = function(image, isSSR, shouldShowVerticalImagery, compact) {
    var imageWidth = compact ? PRODUCT_COMPACT_IMAGE_WIDTH : PRODUCT_IMAGE_WIDTH;
    var imageHeight = compact ? PRODUCT_COMPACT_IMAGE_HEIGHT : PRODUCT_IMAGE_HEIGHT;
    if (shouldShowVerticalImagery) {
        return optimizeImageUrlFillRectangle(image, isSSR, imageWidth, imageHeight, {
            ignoreResizeTag: true
        });
    }
    return optimizeProductImageUrl(image, isSSR, imageWidth);
};
var PRODUCT_IMAGE_WIDTH = 200;
var PRODUCT_IMAGE_HEIGHT = 266;
var PRODUCT_COMPACT_IMAGE_WIDTH = 120;
var PRODUCT_COMPACT_IMAGE_HEIGHT = 160;
